<template>
  <div>
    <label
      v-if="inputData.label"
      :for="`dynamicInput-${inputData.id}`"
      v-html="addNbsp(getLocaleText(inputData.label))"
    ></label>
    <UlTabs
      :items="tabsData"
      :value="responses[formName][inputData.id]"
      tabs-only
      @input="updateValue"
    />
  </div>
</template>

<script>
import formGtm from '@/mixins/formGtm';
import dynamicForms from '@/mixins/dynamicForms';
import { required } from 'vuelidate/lib/validators';
export default {
  name: 'UlButtonsTabs',
  mixins: [formGtm, dynamicForms],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      inputValue: null
    };
  },
  validations() {
    if (this.inputData.required) {
      return {
        inputValue: { required }
      };
    }
    return { inputValue: {} };
  },
  computed: {
    responses() {
      return this.$store.getters[`dynamicForms/responses`];
    },
    tabsData() {
      return this.inputData.values.map(val => ({
        text: this.$te(`${this.inputData.id}.${val}.label`, this.$i18n.locale)
          ? this.$t(`${this.inputData.id}.${val}.label`)
          : this.getLocaleText(val.value),
        value: val.id || val
      }));
    }
  },
  created() {
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => this.validate());
    this.$eventHub.$on(`resetValidationInput_${this.inputData.id}_${this.stepId}`, () =>
      this.reset()
    );

    if (this.responses[this.formName][this.inputData.id]) {
      this.updateValue(+this.responses[this.formName][this.inputData.id], false);
    }

    this.reset();
  },
  destroyed() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
    this.$eventHub.$off(`resetValidationInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    validate() {
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
    },
    reset() {
      if (this.$v) {
        this.$v.$reset();
      }
    },
    updateValue(id, emit = true) {
      this.$v.inputValue.$model = id;
      this.validate();
      const updateResponsePayload = {
        id: this.inputData.id,
        value: this.inputValue,
        formName: this.formName
      };

      this.$store.dispatch('dynamicForms/updateResponse', updateResponsePayload);
      if (emit) {
        this.$emit('update:value');
      }
    }
  }
};
</script>
